// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__qqrL-","search":"SearchBar_search__gheHV","search-icon":"SearchBar_search-icon__EJbtT"};